"use client"

import {
  type ComponentPropsWithoutRef,
  type ComponentRef,
  type Ref,
} from "react"
import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox"
import { cn } from "cn"

import IconCheck from "@/components/icons/check"
import IconMinus from "@/components/icons/minus"

function Checkbox({
  ref,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  ref?: Ref<ComponentRef<typeof CheckboxPrimitive.Root>>
}) {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        "group/checkbox inline-flex size-4 shrink-0 rounded-xs border-[1.5px] border-foreground",
        "data-checked:bg-foreground data-checked:text-background",
        "data-indeterminate:bg-foreground data-indeterminate:text-background",
        "data-disabled:cursor-not-allowed data-disabled:opacity-50",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex size-full items-center justify-center">
        <IconCheck
          size={11}
          strokeWidth={2.75}
          className="hidden group-data-checked/checkbox:block group-data-indeterminate/checkbox:hidden"
        />
        <IconMinus
          size={11}
          strokeWidth={2.75}
          className="hidden group-data-indeterminate/checkbox:block"
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}
Checkbox.displayName = "Checkbox"

export { Checkbox }
